export default __webpack_public_path__ + "255db585f8a0eb28a1e4deb91bde207d.svg";